import { memo, useEffect, useRef } from "react";

import { useToast } from "providers/ToastProvider";

import FunctionalButton from "components/layout/FunctionalButton";

import { ReactComponent as CloseIcon } from "assets/svgs/Close.svg";
// import { ReactComponent as ErrorIcon } from "assets/svgs/toast/Error.svg";
import { ReactComponent as InfoIcon } from "assets/svgs/toast/Info.svg";
import { ReactComponent as WarningIcon } from "assets/svgs/toast/Warning.svg";

const getBackgroundColor = (type) => {
    switch (type) {
        case "success":
            return "bg-primary";

        case "warning":
            return "bg-yellow-500";

        case "error":
            return "bg-warning";

        default:
            return "bg-black70";
    }
};

const ToastIcon = memo(({ type }) => {
    switch (type) {
        case "warning":
        case "error":
            return <WarningIcon className="w-3" />;

        default:
            return <InfoIcon className="w-3" />;
    }
});

const ToastBar = ({ type = "info", message = "", duration = 3000, onClose }) => {
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        const ms = typeof duration === "number" && duration > 0 ? duration : 3000;
        const timeout = setTimeout(() => onCloseRef.current(), ms);

        return () => clearTimeout(timeout);
    }, [duration]);

    return (
        <div
            className={`flex  items-center justify-between rounded-r3 p-2 ${getBackgroundColor(
                type
            )}`}
        >
            <div className="flex  items-center justify-start space-x-2">
                <ToastIcon type={type} className='w-3' />
                <p className="text-h5">{message}</p>
            </div>
            <FunctionalButton icon={<CloseIcon />} onClick={() => onClose()} />
        </div>
    );
};

const ToastsContainer = () => {
    const { toasts, removeToast } = useToast();

    return (
        <div className="absolute left-0 right-0 top-topBar z-50 m-auto mt-2 h-fit w-100 space-y-2">
            {toasts.map((toast) => (
                <ToastBar
                    key={toast.id}
                    {...toast}
                    onClose={() => removeToast(toast.id)}
                />
            ))}
        </div>
    );
};

export default ToastsContainer;
